import * as React from "react";
import { Text } from "@grandvisionhq/elements";
import { useIntl } from "@grandvisionhq/state";
import { isNumber } from "@grandvisionhq/utils";
import { useAccessoriesEcommContext } from "../../../../../../../../../context/modules/EcommContent/AccessoriesEcommContent/context/AccessoriesEcommContext.js";
import { SinglePurchasePriceCaption } from "../../../../../../../../../../components/CTAs/components/modules/EcommContent/components/CTAs/components/SinglePurchasePriceCaption.js";
import { useProductData } from "../../../../../../../../../../../../context/context/product-context-hooks.js";
const AccessoriesCTACaption = () => {
  const { getLabel } = useIntl();
  const { quantity } = useAccessoriesEcommContext();
  const { displayPrice } = useProductData();
  const unitPrice = displayPrice.discountedPrice ?? displayPrice.originalPrice;
  const totalPrice = quantity * unitPrice;
  const addToCartLabel = getLabel("products.actions.addToCart");
  if (isNumber(totalPrice) && quantity > 1) {
    return /* @__PURE__ */ React.createElement(Text, { component: "span", variant: "body-head" }, addToCartLabel, /* @__PURE__ */ React.createElement(SinglePurchasePriceCaption, { isCentAmount: false, price: totalPrice }));
  }
  return /* @__PURE__ */ React.createElement(Text, { component: "span", variant: "body-head" }, addToCartLabel);
};
export {
  AccessoriesCTACaption
};
//# sourceMappingURL=AccessoriesCTACaption.js.map
